// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3e16s","col":"Table_col__2rX5k","fulfillmentStatus":"Table_fulfillmentStatus__MrvlE","emailCol":"Table_emailCol__1QIzD"};